import HeroContent from 'components/HeroConsolidated/shared/HeroContent';
import HeroWrapper, { HeroContentWrapper } from 'components/HeroConsolidated/shared/HeroWrapper';
import { HeroConsolidatedProps } from 'libs/contentful/props';
import { Colorways } from 'types/constants';
import BlogAuthor from './shared/BlogAuthor';
import { formatDate } from 'utils/formatters';
import { cn } from 'utils/styles';
import { liveUpdateAttrs } from 'libs/contentful/utils';

const HeroBlogVariant = ({
  headline,
  sys,
  copy,
  margins,
  sectionName,
  author,
  blogDate,
  className,
  innerClassName,
  isInactiveCarouselSlide,
}: HeroConsolidatedProps) => {
  // Blog Variant does not support any colorway other than white
  const color = { name: Colorways.Primary, value: '#fff' };

  const formattedDate = blogDate ? formatDate(blogDate) : null;

  return (
    <HeroWrapper
      color={color}
      margins={margins}
      sectionName={sectionName}
      className={cn(className, 'py-4 sm:py-4')}
      innerClassName={cn('sm:flex-col sm:gap-20', innerClassName)}
      isInactiveCarouselSlide={isInactiveCarouselSlide}>
      <HeroContentWrapper className="sm:w-full sm:max-w-full">
        {blogDate && (
          <p className="hero-eyebrow text-eyebrow font-sans pb-6" {...liveUpdateAttrs(sys?.id, 'blogDate')}>
            {formattedDate}
          </p>
        )}
        <HeroContent headline={headline} copy={copy} sys={sys} copyClassName="md:max-w-[58%]" />
        {author && <BlogAuthor {...author} className="py-4" />}
      </HeroContentWrapper>
    </HeroWrapper>
  );
};

export default HeroBlogVariant;
